import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";

export default function Login() {
  const { theme } = useTheme();
  const logoSrc = theme === "light" ? "/logo-light.png" : "/logo.png";

  const handleLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL || ""}/auth/google`;
  };

  const error = new URLSearchParams(window.location.search).get("error");

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "var(--bg-base)",
      padding: "24px",
    }}>
      <div style={{ textAlign: "center", maxWidth: 380, width: "100%" }}>
        <div style={{ marginBottom: 40 }}>
          <img
            src={logoSrc}
            alt="Creativedog"
            style={{ height: 56, marginBottom: 16 }}
          />
          <p style={{ color: "var(--text-secondary)", fontSize: 15 }}>
            Plataforma de Agentes IA de Creativedog Agency
          </p>
        </div>

        <div className="card" style={{ padding: 32 }}>
          {error === "unauthorized" && (
            <div style={{
              background: "rgba(239,68,68,0.1)",
              border: "1px solid rgba(239,68,68,0.2)",
              borderRadius: "var(--radius-md)",
              padding: "12px 16px",
              marginBottom: 20,
              fontSize: 13,
              color: "var(--danger)",
            }}>
              Solo pueden acceder cuentas @creativedog.agency
            </div>
          )}

          {error === "server_error" && (
            <div style={{
              background: "rgba(239,68,68,0.1)",
              border: "1px solid rgba(239,68,68,0.2)",
              borderRadius: "var(--radius-md)",
              padding: "12px 16px",
              marginBottom: 20,
              fontSize: 13,
              color: "var(--danger)",
            }}>
              Ocurrió un error al iniciar sesión. Probá de nuevo — si persiste, contactá a soporte.
            </div>
          )}

          <p style={{ color: "var(--text-secondary)", fontSize: 14, marginBottom: 24 }}>
            Accedé con tu cuenta de Google
          </p>

          <button
            onClick={handleLogin}
            className="btn btn-primary btn-lg"
            style={{ width: "100%", justifyContent: "center", fontSize: 15 }}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#fff" fillOpacity=".9"/>
              <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" fill="#fff" fillOpacity=".7"/>
              <path d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#fff" fillOpacity=".5"/>
              <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#fff" fillOpacity=".3"/>
            </svg>
            Continuar con Google
          </button>
        </div>

        <p style={{ marginTop: 20, fontSize: 12, color: "var(--text-muted)" }}>
          Solo cuentas @creativedog.agency tienen acceso
        </p>

        <div style={{ marginTop: 32, display: "flex", gap: 20, justifyContent: "center" }}>
          <Link to="/politicas-de-privacidad" style={{ fontSize: 11, color: "var(--text-muted)", textDecoration: "none" }}
            onMouseEnter={e => e.currentTarget.style.color = "var(--text-secondary)"}
            onMouseLeave={e => e.currentTarget.style.color = "var(--text-muted)"}
          >
            Políticas de privacidad
          </Link>
          <span style={{ fontSize: 11, color: "var(--border)" }}>·</span>
          <Link to="/condiciones-del-servicio" style={{ fontSize: 11, color: "var(--text-muted)", textDecoration: "none" }}
            onMouseEnter={e => e.currentTarget.style.color = "var(--text-secondary)"}
            onMouseLeave={e => e.currentTarget.style.color = "var(--text-muted)"}
          >
            Condiciones del servicio
          </Link>
        </div>
      </div>
    </div>
  );
}
